module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-wrapper scroll-y full-height"
  }, [_c('div', {
    staticClass: "search-container no-margin no-padding"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "item-search",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-category-container no-margin no-padding"
  }), _vm._v(" "), _c('ul', {
    staticClass: "item-list full-height"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.id,
      class: {
        'active': item.id === _vm.selected.id
      },
      on: {
        "click": function($event) {
          _vm.select(item)
        }
      }
    }, [_c('pg-container', {
      attrs: {
        "sm": "12",
        "cls": "p-l-0 p-t-0 p-r-0 p-b-0 no-margin full-height"
      }
    }, [_c('div', {
      staticClass: "m-l-10 list-item-code font-montserrat bold pull-left"
    }, [_vm._v(_vm._s(item.company))]), _vm._v(" "), _c('div', {
      class: {
        'pull-right': true,
        'bold': true,
        'text-success': item.plan === 'free',
          'text-primary': item.plan === 'guru' && !_vm.isExpired(item),
          'text-warning': _vm.isExpired(item),
      }
    }, [_vm._v(_vm._s(item.plan))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "list-item-bottom m-l-10 fs-12 font-montserrat"
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n          "), _c('div', {
      staticClass: "list-item-footer"
    }, [_vm._v("                      \n            " + _vm._s(item.email) + "                        \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864c482e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/OrganizationList.vue
// module id = 1382
// module chunks = 1